import { create } from 'zustand'
import { DomainContextProps } from './storeTypes/domain.storeTypes'
import { ExamStoreTypes } from './storeTypes/exam.storeTypes'




const useExamStores = create<ExamStoreTypes>((set) => ({
    setProctorAuthToken:(data:string)=>set(()=>({proctorAuthToken:data})),
    faceVerfied:false,
    CameraFound:false,
    proctorAuthToken:"",
    setFaceVerified:(data:boolean)=>set(()=>({faceVerfied:data})),
    setCameraFound:(data:boolean)=>set(()=>({CameraFound:data}))
}))

export default useExamStores